import { style } from "@vanilla-extract/css";
import {
  primitiveTokens,
  semanticThemeTokens
} from "../../theme/ThemeTokens.css";

export const details = style({
  position: "relative",
  textAlign: "left",
  marginTop: primitiveTokens.sizing["6x"],
  marginBottom: primitiveTokens.sizing["6x"],
  padding: primitiveTokens.sizing["4x"],
  backgroundColor: semanticThemeTokens.errorDetails.container.backgroundColor,
  borderColor: semanticThemeTokens.errorDetails.container.borderColor,
  borderWidth: primitiveTokens.borderWidth.default,
  borderStyle: "solid",
  borderRadius: primitiveTokens.radii.md,
  width: "100%"
});

export const detailsSummary = style({
  cursor: "pointer",
  fontSize: primitiveTokens.type.sm,
  fontWeight: 600,
  marginBottom: primitiveTokens.sizing["2x"],
  color: semanticThemeTokens.errorDetails.summary.textColor,
  outline: "none"
});

export const copyButton = style({
  position: "absolute",
  top: primitiveTokens.sizing["2x"],
  right: primitiveTokens.sizing["2x"],
  zIndex: 1
});

export const errorStack = style({
  fontSize: primitiveTokens.type.xs,
  overflow: "auto",
  maxHeight: "200px",
  color: semanticThemeTokens.errorDetails.stack.textColor,
  backgroundColor: semanticThemeTokens.errorDetails.stack.backgroundColor,
  padding: primitiveTokens.sizing["2x"],
  borderRadius: primitiveTokens.radii.sm
});
